// apps/dashboard/src/hooks/use-mentions.ts
// TanStack Query hooks for @agent mentions — H1-01 T7.

import { api } from '@/lib/api';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

export interface MentionDto {
  id: string;
  tenantId: string;
  messageId: string;
  conversationId: string;
  mentionedAgentId: string;
  notifiedAt: string | null;
  readAt: string | null;
  createdAt: string;
}

interface MentionsResponse {
  mentions: MentionDto[];
  unreadCount: number;
}

export function useMentions() {
  return useQuery<MentionsResponse>({
    queryKey: ['mentions'],
    queryFn: () => api.get('/me/mentions'),
    refetchInterval: 30_000, // poll every 30 s
  });
}

export function useMentionCount() {
  const { data } = useMentions();
  return data?.unreadCount ?? 0;
}

export function useMarkMentionRead() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => api.patch(`/me/mentions/${id}/read`, {}),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['mentions'] });
    },
  });
}

export function useMarkAllMentionsRead() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: () => api.post('/me/mentions/read-all', {}),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['mentions'] });
    },
  });
}
